import { SearchResult, SearchType } from '@/app/(main)/_components/search-modal/search-modal.types';

export const mostSearchedProceduresElasticTest: SearchResult[] = [
  {
    id: '734e0857-61ac-4d49-91b2-faba67f27993',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Oftalmologista',
    subText: 'Consulta presencial - 10.10.10.12 - 225265',
    code: '10101012 - 225265',
    slug: 'consulta-em-consultorio-oftalmologia',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: 'df67d3c1-2d16-4f2e-9374-4b1e6750d0d4',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Clínico Geral',
    subText: 'Consulta presencial - 10.10.10.12 - 225125',
    code: '10101012 - 225125',
    slug: 'consulta-em-consultorio-clinico-geral-ou-clinica-medica',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: '53941341-03f7-43f0-a8d3-1b82f66380ab',
    searchType: SearchType.ONLINE_CONSULTATION,
    displayName: 'Teleconsulta com Clínico Geral',
    subText: 'Teleconsulta - 14.57.28.33',
    code: '14572833',
    slug: 'consulta-em-consultorio-clinico-geral-ou-clinica-medica-online',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: '830d1c0f-d12e-4c5b-9911-a7e3258b43f1',
    searchType: SearchType.LABORATORIAL_EXAM,
    displayName: 'Hemograma Completo (com Contagem de Plaquetas)',
    subText: 'Exame Laboratorial - 40.30.43.61',
    code: '40304361',
    slug: 'hemograma-meu-amigo-se-algum-procedimento-tiver-um-nome-maior-que-o-desse-hemograma-ai-lascou-porque-agora-vamos-limitar-para-256-o-nome-desse-procedimento-ta-gigante-assim-apenas-para-testar-espero-que-entendam-hahaha-hihi-fb6dfe6d989979d068cc56a614581c30',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: 'c6c50a00-6a56-4aac-a375-e774e7c0b8af',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Psiquiatra',
    subText: 'Consulta presencial - 10.10.10.39 - 225133',
    code: '10101039 - 225133',
    slug: 'consulta-em-pronto-socorro-psiquiatria',
    source: 'ELASTIC_SEARCH',
  },
];
